// @page rules can't be scoped by Svelte, and every component's CSS lives in one
// global bundle — so a static @page in one print view leaks into all the others.
// Instead, each print view injects its @page rule while mounted.
// Call from onMount and return the cleanup: onMount(() => printPage('size: A4; margin: 10mm;'))
export function printPage(rules) {
  const el = document.createElement('style');
  el.textContent = `@page { ${rules} }`;
  document.head.appendChild(el);
  return () => el.remove();
}
